module.exports = __webpack_public_path__ + "img/f1@2x.b2f2198f.png";